module.exports = __webpack_public_path__ + "img/SKMA_noCellphone.2914cc3f.png";